import {
  FETCH_CONTENT_RESPONSE,
  FETCH_CONTENT_RESPONSE_PRIMARY,
  FETCH_CONTENT_ERROR,
  BUILD_CONTENT,
  FETCH_INITIAL_STATE
} from './types'

import buildJson from '../../utils/build-json'

const formatData = (state, payload) => {
  const { page, data } = payload
  const jsonBuild = page.buildJson || buildJson

  return {
    ...state,
    [page.name]: {
      fetchedData: true,
      built: true,
      contents: jsonBuild(
        page.modules,
        data.contents,
        page.transform,
        page.moduleKey
      )
    }
  }
}

const getInitialState = () => {
  const found = initialState.find(item => {
    return item.content
  })
  return found ? found.content : {}
}

export default (state = getInitialState(), action) => {
  switch (action.type) {
    case FETCH_CONTENT_RESPONSE:
      return {
        ...state,
        [action.payload.page]: {
          ...action.payload.data
        }
      }
    case FETCH_CONTENT_RESPONSE_PRIMARY:
      return formatData(state, action.payload)
    case FETCH_CONTENT_ERROR:
      console.log('FETCH_CONTENT_ERROR', action.payload)
      return state
      break
    case BUILD_CONTENT:
      return formatData(state, action.payload)
    case FETCH_INITIAL_STATE:
      // Set data to global variable
      initialState = action.payload
      return { ...state, ...getInitialState() }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/services/content/reducer.js